import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccountService, HttpCommonService, LocalStoreManager } from ".";
import { OrderSettingModel } from "../../../../../src/app/frontoffice/order/model/ordersetting.model";
import { SplashFormService } from "../../../../sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SideMenuState } from "../models/common.model";
import { LocalSettingModel, UserSettingModel } from "../models/usersetting.model";
import { ClearableCache } from "../models/clearablecache.model";
import { FormSettingModel } from "../models/formsettingmodel";

@Injectable({ providedIn: "root" })
export class CommonService implements OnDestroy {
  ngUnsubscribe = new Subject<void>();
  public sidemenuState: SideMenuState = SideMenuState.toggle;
  public oldSidemenuState: SideMenuState = SideMenuState.toggle;
  public isMobileMode: boolean;
  public isDigitalMenu: boolean;
  public LocalSetting: LocalSettingModel;
  public UserSettingModel: UserSettingModel;

  public getUserSetting: Subject<any> = new Subject<any>();
  public smartConnection: boolean;
  constructor(
    public storage: LocalStoreManager,
    private httpCommonService: HttpCommonService,
    private splashFormService: SplashFormService,
    private accountService: AccountService
  ) {
    this.setLocalSetting();
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    if (this.getUserSetting) {
      this.getUserSetting.next();
      this.getUserSetting.complete();
    }
  }
  getSetting() {
    const setting = this.storage.getData("UserSettingModel");
    if (!setting) {
      this.httpCommonService
        .getList("UserLocalSetting/GeUserSetting/" + this.accountService.getCurrentUser().Id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: UserSettingModel) => {
            if (data) {
              this.LocalSetting = new LocalSettingModel();
              this.LocalSetting = JSON.parse(data.DataValue);
              if (!this.LocalSetting.OrderSetting) {
                this.LocalSetting.OrderSetting = new OrderSettingModel();
              }
              this.UserSettingModel = data;
              this.storage.savePermanentData(this.UserSettingModel, "UserSettingModel");
            } else {
              this.LocalSetting = new LocalSettingModel();
              this.UserSettingModel = new UserSettingModel();
            }
            this.setLocalSetting();
            this.getUserSetting.next(true);
          },
          (err) => {
            this.splashFormService.closeLoading();
          }
        );
    } else {
      this.LocalSetting = JSON.parse(setting.DataValue);
      this.UserSettingModel = setting;
      this.setLocalSetting();
      this.getUserSetting.next(true);
    }
  }
  updateSettings(OrderSetting?: OrderSettingModel) {
    if (!this.accountService?.getCurrentUser()?.Id) return;
    if (OrderSetting) {
      const setting = this.storage.getData("UserSettingModel");
      this.LocalSetting = JSON.parse(setting.DataValue);
      this.UserSettingModel = setting;
      this.setLocalSetting();
      this.LocalSetting.OrderSetting = OrderSetting;
    }
    this.httpCommonService
      .get("UserLocalSetting/GeUserSetting/" + this.accountService?.getCurrentUser()?.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: UserSettingModel) => {
          if (data) {
            this.splashFormService.openDialog();
            this.LocalSetting.SideMenuState = this.sidemenuState;
            this.UserSettingModel.DataValue = JSON.stringify(this.LocalSetting);
            data.DataValue = JSON.stringify(this.LocalSetting);
            this.storage.savePermanentData(data, "UserSettingModel");
            if (data?.Id) {
              this.UserSettingModel.DataValue = JSON.stringify(this.LocalSetting);
              this.httpCommonService
                .create("UserLocalSetting/UpdateData", data)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (data: any) => {
                    this.splashFormService.closeLoading();
                  },
                  (error) => {
                    this.splashFormService.closeLoading();
                    console.log(error);
                  }
                );
            } else {
              this.UserSettingModel = new UserSettingModel();
              this.UserSettingModel.UserId = this.accountService?.getCurrentUser()?.Id;
              this.UserSettingModel.DataValue = JSON.stringify(this.LocalSetting);
              this.httpCommonService
                .create("UserLocalSetting/SaveData", this.UserSettingModel)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (data: number) => {
                    if (!this.UserSettingModel) this.UserSettingModel = new UserSettingModel();
                    this.UserSettingModel.Id = data;
                    this.storage.savePermanentData(this.UserSettingModel, "UserLocalSettingModel");
                  },
                  (error) => {
                    this.splashFormService.closeLoading();
                    console.log(error);
                  }
                );
            }
          } else {
            this.splashFormService.openDialog();
            this.LocalSetting.SideMenuState = this.sidemenuState;
            this.UserSettingModel.DataValue = JSON.stringify(this.LocalSetting);
            this.storage.savePermanentData(this.UserSettingModel, "UserSettingModel");
            if (this.UserSettingModel?.Id) {
              this.UserSettingModel.DataValue = JSON.stringify(this.LocalSetting);
              this.httpCommonService
                .update("UserLocalSetting/UpdateData", this.UserSettingModel)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (data: any) => {
                    data;
                    this.splashFormService.closeLoading();
                  },
                  (error) => {
                    this.splashFormService.closeLoading();
                    console.log(error);
                  }
                );
            } else {
              this.UserSettingModel = new UserSettingModel();
              this.UserSettingModel.UserId = this.accountService?.getCurrentUser()?.Id;
              this.UserSettingModel.DataValue = JSON.stringify(this.LocalSetting);
              this.httpCommonService
                .create("UserLocalSetting/SaveData", this.UserSettingModel)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (data: number) => {
                    if (!this.UserSettingModel) this.UserSettingModel = new UserSettingModel();
                    this.UserSettingModel.Id = data;
                    this.storage.savePermanentData(this.UserSettingModel, "UserLocalSettingModel");
                    this.splashFormService.closeLoading();
                  },
                  (error) => {
                    this.splashFormService.closeLoading();
                    console.log(error);
                  }
                );
            }
          }
        },
        (error) => {
          this.splashFormService.closeLoading();
          console.log(error);
        }
      );
  }
  setLocalSetting() {
    if (!this.LocalSetting) this.LocalSetting = new LocalSettingModel();
    this.setTheme();
    this.setPinned();
    this.setDirection();
  }
  setTheme(theme?: string) {
    if (!theme) {
      if (!this.LocalSetting || !this.LocalSetting?.Theme) {
        theme = "sepidz";
        this.LocalSetting.Theme = theme;
        document.documentElement.className = theme;
      } else {
        document.documentElement.className = this.LocalSetting.Theme;
      }
    } else {
      this.LocalSetting.Theme = theme;
      document.documentElement.className = theme;
      this.updateSettings();
    }
  }

  setPinned(pinned?: boolean) {
    if (pinned === undefined || null) {
      pinned = false;
    }
    this.LocalSetting.isPinned = pinned;
    this.updateSettings();
  }

  setDirection(isrtl?: string) {
    if (!isrtl) {
      if (this.LocalSetting?.Isrtl) {
        document.documentElement.dir = this.LocalSetting?.Isrtl;
        return;
      }
      this.LocalSetting.Isrtl = "rtl";
      document.documentElement.dir = this.LocalSetting.Isrtl;
    } else {
      this.LocalSetting.Isrtl = isrtl;
      document.documentElement.dir = this.LocalSetting.Isrtl;
    }
  }
  getFormSetting(settingUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.httpCommonService
        .getList(settingUrl)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((result: FormSettingModel[]) => {
          if (result?.length > 0) this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
          resolve(true);
        });
    });
  }
  getDriverSettlementFormSetting(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.httpCommonService
        .getList("DriverSettlementFormSetting")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((result: FormSettingModel[]) => {
          if (result?.length > 0) this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
          resolve(true);
        });
    });
  }
  getDepositFormSetting(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.httpCommonService
        .getList("DepositFormSetting")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((result: FormSettingModel[]) => {
          if (result?.length > 0) this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
          resolve(true);
        });
    });
  }
}
